import { useEffect } from "react";

/**
 * Marks `<html>` with what the docked onboarding is showing in the
 * bottom-right corner, so fixed page furniture that lives there can move out of
 * its way — today the back-to-top button (`.scroll-to-top` in `main.css`),
 * which would otherwise sit underneath the sheet or the pill.
 *
 * An attribute rather than a prop because that button belongs to
 * `react-scroll-to-top`, mounted in the root layout, and is positioned by a
 * global stylesheet.
 */
export function useDockedFootprint(footprint: "sheet" | "pill") {
  useEffect(() => {
    const root = document.documentElement;
    root.dataset.onboardingDocked = footprint;
    return () => {
      delete root.dataset.onboardingDocked;
    };
  }, [footprint]);
}
